{{ 'communications.content-management.description' | translate }}
<ul class="list-unstyled">
  <li *ngFor="let settingBatch of settingBatches">
    <a target="_blank" href="#" (click)="$event.preventDefault(); weeblyLogin(settingBatch)">{{
      settingBatch ? settingBatch : 'Default'
    }}</a>
  </li>
</ul>
